import { Button, Form, Input } from 'antd';
import { reset } from '../../lib/firebase.ts';
import { useState } from 'react';
import { useAuth } from './AuthContext.tsx';
import { Link, useNavigate } from 'react-router-dom';

export const ResetForm = () => {
  const { error } = useAuth();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const handleReset = async (data: { email: string }) => {
    setIsLoading(true);
    await reset(data.email);
    setIsLoading(false);
    navigate('/auth/sign-in');
  };

  return (
    <Form
      name="login-form"
      labelCol={{ span: 10 }}
      wrapperCol={{ span: 14 }}
      onFinish={handleReset}
      onFinishFailed={console.error}
      autoComplete={'off'}
      disabled={isLoading}
    >
      <Form.Item<string>
        label="メールアドレス"
        name="email"
        rules={[{ required: true, message: 'メールアドレスを入力してください' }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        wrapperCol={{
          offset: 0,
          span: 24,
          sm: { offset: 8, span: 16 },
        }}
      >
        <Button type="primary" htmlType="submit" loading={isLoading}>
          パスワードをリセットする
        </Button>
      </Form.Item>

      {error && <div style={{ color: 'red' }}>{error}</div>}

      <Link to={'/auth/sign-up'}>新規登録はこちら</Link>
    </Form>
  );
};
